import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("md_cookie_consent")) setShow(true);
  }, []);
  if (!show) return null;
  const accept = () => { localStorage.setItem("md_cookie_consent", "1"); setShow(false); };
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-navy text-white p-4 md:p-5" data-testid="cookie-consent">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-4 justify-between">
        <p className="text-sm text-gray-300">
          We use cookies to improve your experience and analyse traffic. See our{" "}
          <Link to="/legal/cookie-policy" className="text-gold underline">Cookie Policy</Link>.
        </p>
        <div className="flex gap-3">
          <button onClick={() => setShow(false)} className="text-sm text-gray-400 hover:text-white px-4 py-2" data-testid="cookie-decline">Decline</button>
          <Button onClick={accept} data-testid="cookie-accept" className="bg-gold text-navy hover:bg-gold-dark">Accept</Button>
        </div>
      </div>
    </div>
  );
}
